import axios from 'axios';
import jose from 'node-jose';
import apiRoute from './apiRoute';
require('dotenv');

const instance = axios.create({

    baseURL : apiRoute.baseUrlBot,
});

function encrypt(data){
    return new Promise((resolve, reject)=>{
        jose.JWK.asKeyStore(keystore).then(result => {
            jose.JWE.createEncrypt({ format: 'compact', zip: true }, result.get(keystore.keys[0].kid))
                .update(JSON.stringify(data))
                .final()
                .then(res => {
                    return resolve(res);
                }).catch((err) => {
                return reject(err);
            });
        });
    })
}


let keystore = {
    keys: [
        {
            "kty": process.env.REACT_APP_KTY,
            "kid": process.env.REACT_APP_KID,
            "use": process.env.REACT_APP_USE,
            "alg": process.env.REACT_APP_ALG,
            "k": process.env.REACT_APP_K
        }
    ]
};


instance.interceptors.request.use( async req => {
        let data = '';
        data = await encrypt(req.data);
        req.data = { payload :data };
        return req;
    }, err => {
        return Promise.reject(err);
    }
);



instance.interceptors.response.use( async res => {
    return res;
}, err => {
    return Promise.reject(err);
});

export default instance;